import React from 'react'
import './styles.scss';

import World from '../../assets/svg/world.svg';
import Open from '../../assets/svg/open.svg';
import Gaming from '../../assets/svg/gaming.svg';
import { ReactComponent as Blob } from './blob.svg';

function Presentation(props) {

    return (
        <div className="section presentation">
            <div className="values">
                <div className="value decentralized">
                    <div className="content">
                        <h2>Decentralized</h2>
                        <p>
                            BilleGateCoin does not have a central authority, no entity owns or controls the network.<br/>
                            The players decide the rules of the network. They validate each and every transaction happening on the network in real-time and agree upon the fixed issuance of marbles.    
                        </p>

                    </div>
                    <img src={World}/>
                </div>

                <div className="value open">
                    <Blob className="blob first"/>
                    <div className="content">
                        <h2>Open</h2>
                        <p>
                            The network is open to everyone. No matter who you are, there exists no restriction on the use of this platform.<br/>
                            Anyone can take part of the network, by playing, transacting, mining, or contributing to the core implemention of BilleGateCoin. 
                        </p>
                    </div>
                    <img src={Open}/>
                </div>

                <div className="value fun">
                    <div className="content">
                        <h2>Fun</h2>
                        <p>
                            The marble game is a century-old game that has entertained generations.<br/>
                            Earn marbles by winning duels, exchanging marbles, or securing the network by mining.<br/>
                            Impress your friends by showing your marble collection with your <a target="_blank" href="https://docs.scatteredcorp.tech/#/wallet?id=address">public key</a>.
                        </p>
                    </div>
                    <img src={Gaming}/>
                    <Blob className="blob first"/>
                </div>
            </div>

        </div>
    )
}

export default Presentation;